import React from 'react';
import PropTypes from 'prop-types';
import style from './style.scss';

const Stars = ({rating, single = false}) => {
    let stars = [];
    let maxStar = 5;

    for(let i = 1; i <= maxStar; i++) {
        stars.push(<i className={`stars-icon jumbo-icon-star ${i <= rating && 'yellow'}`} key={i}></i>);
    }

    return (
        <div className="stars">
            {single ? <i className='stars-icon jumbo-icon-star yellow'></i> : stars.map((elem) => elem )}
        </div>
    )
}

Stars.propTypes = {
    single: PropTypes.bool,
    rating: PropTypes.number,
};

export default Stars;